import { FIXED_NUMBERS } from '../../lib/params';
import s from '../Landing.module.css';

/** Fixed parameters shared by every launch (non-configurable). */
export function ProtocolNumbers() {
  return (
    <section className={s.section} aria-labelledby="numbers">
      <h2 id="numbers" className={s.h2}>
        Fixed for every launch
      </h2>
      <dl className={s.numbers}>
        {FIXED_NUMBERS.map(([k, v]) => (
          <div key={k} className="px-panel">
            <dt>{k}</dt>
            <dd>{v}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
